import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useExecutionFocusNav } from '../hooks/useEquitiesMode';

/** Slim-nav hint in execution-focus (equities-only) deployments. */
export default function ExecutionFocusBanner() {
  const executionFocus = useExecutionFocusNav();
  if (!executionFocus) return null;

  return (
    <div className="rounded-lg border border-primary/20 bg-primary/5 px-4 py-2.5 text-sm text-muted-foreground flex flex-wrap items-center gap-2 mb-4">
      <Shield className="w-4 h-4 text-primary shrink-0" />
      <span>
        <strong className="text-foreground font-medium">Execution focus</strong>
        {' — '}
        Navigation is trimmed to autonomous trading, positions, exits, and reporting.
      </span>
      <Link to="/settings" className="text-primary font-medium hover:underline underline-offset-4">
        Settings
      </Link>
      <span className="text-muted-foreground/60">·</span>
      <Link to="?tools=1" className="text-primary font-medium hover:underline underline-offset-4">
        Show research tools
      </Link>
    </div>
  );
}
